import { serviceList } from "../data/services";
import { useMobile } from "../hooks/useMobile";
import { useSEO } from "../hooks/useSEO";
import {
  KAP, Ac, Dugme, BolumBas, Dizin, DizinSatir, Madde,
  ALTIN, ALTIN_PARLAK, ALTIN_KOYU, INK, INK_2, INK_3,
  KAGIT, KAGIT_2, CIZGI, DISPLAY, GOVDE,
  BLOK,} from "../components/Ui";
import { ALINTI } from "../data/constants";

/* =============================================================
   ANA SAYFA

   Eski ana sayfada WebGL shader, gökkuşağı yayı, yüzen parçacıklar ve
   dönen kelime animasyonu vardı. Hepsi kaldırıldı: hiçbiri müşteriyi
   ikna etmiyordu, sayfayı ağırlaştırıyordu ve bölümlerin bir kısmı
   animasyon tetiklenmeyince BOŞ görünüyordu.

   Yeni sıra, ziyaretçinin sorularına göre:
     1. İDDİA      ne yapıyoruz + tek ortakla kapsam (ilk ekranda)
     2. KANIT      müşterinin gördüğü rapor ekranı  <- ayırt edici bölüm
     3. HİZMETLER  dokuz alan, taranabilir dizin
     4. MANİFESTO  neden böyle çalışıyoruz
     5. SÜREÇ      dört adım
     6. FARK       altı somut madde
     7. KAPANIŞ    ücretsiz analiz + eğitim

   Kanıt bölümü sayfanın kalbi: "şeffaf raporluyoruz" cümlesini herkes
   yazıyor, ekranı gösteren yok.
   ============================================================= */

const KAPSAM = [
  ["01", "Strateji", "Konumlandırma, pazar analizi, yıllık hedefler"],
  ["02", "Prodüksiyon", "Senaryo, çekim, kurgu"],
  ["03", "Dijital reklam", "Google, Meta, TikTok, LinkedIn"],
  ["04", "Yazılım", "Site, e-ticaret, özel geliştirme"],
];

const ILKELER = [
  ["01", "Marka önce, reklam sonra", "Çoğu ajans hemen reklam açar. Biz önce markanın nasıl hissettirdiğine bakarız."],
  ["02", "Geleneksel ve dijital", "Hızlı içerik satış getirir, iyi hikaye marka inşa eder. İkisi de lazım."],
  ["03", "Kampanya değil, sonuç", "Neyin işe yarayıp neyin yaramadığını veriye bakarak söylüyoruz."],
  ["04", "Türkiye'den dünyaya", "Web sitenizden global pazarlara açılıma kadar tüm altyapıyı kuruyoruz."],
  ["05", "Kod da yazıyoruz", "Teknik ihtiyaçlarınız için ayrı bir ajans aramanıza gerek yok."],
  ["06", "Senaryo bizden", "Ürününüzü, markanızı, mesajınızı doğru kelimelerle anlatıyoruz."],
];

const ADIMLAR = [
  ["01", "Analiz ve keşif", "Markanızı, sektörünüzü ve rakiplerinizi derinlemesine inceliyoruz."],
  ["02", "Strateji ve planlama", "Verilere dayalı bir büyüme stratejisi ve yol haritası çıkarıyoruz."],
  ["03", "Üretim ve uygulama", "Kreatifler, reklamlar, içerikler. Hepsini üretip yayına alıyoruz."],
  ["04", "Ölçüm ve optimizasyon", "Sonuçları takip ediyor, sürekli iyileştirerek büyümeyi hızlandırıyoruz."],
];

const FARKLAR = [
  ["Önce araştırıyoruz", "Ürünün, pazarın, rakiplerin. Körü körüne reklam açmıyoruz.",
"M11 4a7 7 0 100 14 7 7 0 000-14zM20 20l-4.3-4.3M11 8v6M8 11h6"],
  ["Prodüksiyon dahil", "Senaryo yazımı, çekim, kurgu. Başka bir ekip aramıyorsunuz.",
"M2 8a2 2 0 012-2h10a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2zM16 10l6-3v10l-6-3z"],
  ["Yurt dışı pazarlar", "Mail marketing ve global stratejilerle sınır ötesi büyüme.",
"M12 3a9 9 0 100 18 9 9 0 000-18zM3 12h18M12 3c2.5 3 2.5 15 0 18M12 3c-2.5 3-2.5 15 0 18"],
  ["Şeffaf raporlama", "Yukarıdaki ekran. Her hafta, her ay, gerekçesiyle birlikte.",
"M4 19V9M10 19V5M16 19v-7M22 19H2"],
  ["E-ticaret uzmanlığı", "Trendyol'dan Amazon'a, mağaza kurulumundan reklamına.",
"M3 9l2-5h14l2 5M4 9v11h16V9M9 20v-6h6v6"],
  ["Tek muhatap", "Tek ajans, tek kişi. Sıfır koordinasyon derdi.",
"M12 4.6a3.4 3.4 0 100 6.8 3.4 3.4 0 000-6.8zM4.5 20c0-4 3.4-6.4 7.5-6.4s7.5 2.4 7.5 6.4"],
];

export default function HomePage({ onNavigate }) {
  const mobil = useMobile();
  useSEO({
    title: "Reklam & Pazarlama Ajansı: A'dan Z'ye Marka Yönetimi",
    description: "Türkiye'nin tam kapsamlı reklam ve pazarlama ajansı. Marka stratejisi, dijital reklam, sosyal medya, prodüksiyon, SEO, e-ticaret, web tasarım. 9 hizmet, tek ajans.",
    path: "/",
  });

  const git = (sayfa) => (e) => { e.preventDefault(); onNavigate(sayfa); };

  return (
    <div>
      {/* ---------- 1. İDDİA ---------- */}
      <section style={{ padding: mobil ? "56px 0 48px" : "88px 0 76px" }}><div style={{
          ...KAP, display: "grid",
          gridTemplateColumns: mobil ? "1fr" : "1.18fr .82fr",
          gap: mobil ? 38 : 56, alignItems: "center",
        }}><div><h1 style={{ fontSize: "clamp(42px,5.4vw,72px)", maxWidth: "16ch" }}>
              Reklam satmıyoruz.{" "}
              <span style={{ color: ALTIN }}>Marka inşa ediyoruz.</span></h1><p style={{
              fontFamily: GOVDE, marginTop: 24, fontSize: 19,
              color: INK_2, maxWidth: "48ch",
            }}>
              Strateji, prodüksiyon, dijital ve yazılım. Hepsi tek ekipte,
              tek muhatapla. Ne yaptığımızı her hafta rakamla gösteriyoruz.
            </p><div style={{ marginTop: 34, display: "flex", gap: 12, flexWrap: "wrap" }}><Dugme href="/iletisim" onClick={git("contact")}>Ücretsiz analiz al</Dugme><Dugme tur="acik" href="#kanit"onClick={(e) => {
                       e.preventDefault();
                       document.getElementById("kanit")
                         ?.scrollIntoView({ behavior: "smooth", block: "start" });
                     }}>Raporumuzu görün</Dugme></div></div>

          {/* Kapsam paneli: "tek ortakla tam kapsam" iddiasını ilk ekranda
              görünür kılar. Soyut rakam yerine dört somut kalem. */}
          <Ac><div style={{ border: `1px solid ${CIZGI}`, borderRadius: 14, overflow: "hidden" }}><div style={{
                padding: "14px 20px", borderBottom: `1px solid ${CIZGI}`,
                background: KAGIT_2, fontFamily: DISPLAY, fontSize: 11.5,
                fontWeight: 700, letterSpacing: "0.12em",
                textTransform: "uppercase", color: INK_3,
              }}>Tek ortakla, tam kapsam</div>
              {KAPSAM.map(([no, ad, alt], i) => (
                <div key={no} style={{
                  display: "flex", alignItems: "baseline", gap: 14,
                  padding: "15px 20px",
                  borderBottom: i < KAPSAM.length - 1 ? `1px solid ${CIZGI}` : 0,
                }}><span className="sayi" style={{
                    fontFamily: DISPLAY, fontSize: 12, fontWeight: 700,
                    color: ALTIN_KOYU, width: 20, flex: "none",
                  }}>{no}</span><div><b style={{ fontFamily: GOVDE, fontSize: 15, fontWeight: 600 }}>{ad}</b><span style={{ display: "block", fontFamily: GOVDE,
                                   fontSize: 13.5, color: INK_3, marginTop: 2 }}>{alt}</span></div></div>
              ))}
            </div></Ac></div></section>

      {/* ---------- 2. KANIT ---------- */}
      <section id="kanit" style={{
        background: BLOK, color: KAGIT, marginTop: mobil ? 56 : 76,
        padding: mobil ? "64px 0 0" : "96px 0 0", overflow: "hidden",
      }}><div style={{
          ...KAP, display: "grid",
          gridTemplateColumns: mobil ? "1fr" : "1.1fr .9fr",
          gap: mobil ? 32 : 52, alignItems: "end", marginBottom: 52,
        }}><Ac><h2 style={{ fontSize: "clamp(32px,4.2vw,52px)", maxWidth: "15ch", color: KAGIT }}>
              Şeffaflık bir söz değil.{" "}
              <span style={{ color: ALTIN_PARLAK }}>Bir ekran.</span></h2></Ac><Ac gecikme={80}><p style={{ fontFamily: GOVDE, fontSize: 16.5,
                        color: "rgba(251,250,246,.62)", maxWidth: "40ch" }}>
              Müşterilerimiz kendi raporlarına istedikleri an giriyor. Ne harcandı,
              ne döndü, hangi gün neye dokunduk ve neden dokunduk. Hepsi yazılı.
            </p><div style={{ display: "flex", flexWrap: "wrap", gap: 10, marginTop: 22 }}>
              {["Kendi giriş bilgileriyle", "Gün, hafta, ay kırılımı",
"Her müdahalenin gerekçesi", "PDF olarak indirilebilir"].map((t) => (
                <span key={t} style={{
                  fontFamily: GOVDE, fontSize: 13, color: "rgba(251,250,246,.8)",
                  padding: "6px 13px", borderRadius: 999,
                  border: "1px solid rgba(251,250,246,.18)",
                }}>{t}</span>
              ))}
            </div></Ac></div><div style={KAP}><Ac>
            {/* Ekran alttan taşar: "devamı var" hissi verir, kesilmiş görünmez. */}
            <div style={{
              borderRadius: "14px 14px 0 0", overflow: "hidden",
              border: "1px solid rgba(251,250,246,.16)", borderBottom: 0,
              marginBottom: -2,
            }}><img src="/rapor-paneli.jpg" width="1500" height="979" loading="lazy"alt="Whayns Dijital müşteri raporlama paneli: dönem harcaması, ciro, kazanç oranı ve günlük grafikler"style={{ display: "block", width: "100%", height: "auto" }} /></div></Ac></div><div style={KAP}><p style={{
            fontFamily: GOVDE, fontSize: 13.5, color: "rgba(251,250,246,.5)",
            padding: "26px 0 60px", borderTop: "1px solid rgba(251,250,246,.12)",
          }}>
            Ekrandaki marka adı ve rakamlar örnektir. Gerçek müşteri verileri paylaşılmaz.
          </p></div></section>

      {/* ---------- 3. HİZMETLER ---------- */}
      <section style={{ padding: mobil ? "60px 0" : "92px 0" }}><div style={KAP}><Ac><BolumBas baslik="Dokuz alan, tek ekip"yan="Birden fazla ajansla uğraşmak yok. Koordinasyon sizin işiniz değil." /></Ac><Dizin>
            {serviceList.map((h, i) => (
              <Ac key={h.id}><DizinSatir
                  no={String(i + 1).padStart(2, "0")}
                  baslik={h.title.replace(/\s*&\s*/g, " ve ").replace(/\s*,\s*/g, ", ")}
                  aciklama={h.desc.replace(/\s*,\s*/g, ". ")}
                  href={`/hizmetler/${h.id}`}
                  onClick={git(h.id)}
                /></Ac>
            ))}
          </Dizin></div></section>

      {/* ---------- 4. MANİFESTO ---------- */}
      <section style={{ background: KAGIT_2, padding: mobil ? "60px 0" : "92px 0" }}><div style={KAP}><Ac>
            {/* Sitedeki TEK serif kullanımı: alıntı. Her yerde serif
                kullanmak "premium" değil, kararsız görünüyor. */}
            <p style={{
              fontFamily: ALINTI, fontStyle: "italic", fontWeight: 400,
              fontSize: "clamp(28px,4.2vw,54px)", lineHeight: 1.16,
              letterSpacing: "-0.015em", maxWidth: "20ch", color: INK,
            }}>
              Diğerleri reklam satar.<br /><span style={{ color: ALTIN }}>Biz marka inşa ederiz.</span></p></Ac><div style={{
            marginTop: 56, display: "grid",
            gridTemplateColumns: mobil ? "1fr" : "repeat(3,1fr)",
            borderTop: `1px solid ${CIZGI}`,
          }}>
            {ILKELER.map(([no, b, m], i) => (
              <Ac key={no} gecikme={(i % 3) * 60}><div style={{
                  padding: mobil ? "24px 0 26px" : "26px 30px 30px 0",
                  borderRight: !mobil && (i % 3 !== 2) ? `1px solid ${CIZGI}` : 0,
                  borderTop: i >= 3 && !mobil ? `1px solid ${CIZGI}` : 0,
                  borderBottom: mobil && i < ILKELER.length - 1 ? `1px solid ${CIZGI}` : 0,
                  paddingTop: i >= 3 && !mobil ? 26 : undefined,
                  height: "100%",
                }}><Madde no={no} baslik={b} metin={m} /></div></Ac>
            ))}
          </div></div></section>

      {/* ---------- 5. SÜREÇ ---------- */}
      <section style={{ padding: mobil ? "60px 0" : "92px 0" }}><div style={KAP}><Ac><BolumBas baslik="Veriyle başlar, sonuçla biter"yan="Dört adım. Her adımın çıktısı size yazılı olarak teslim edilir." /></Ac><div style={{
            display: "grid", gap: 22, paddingTop: 30,
            borderTop: `1px solid ${CIZGI}`,
            gridTemplateColumns: mobil ? "1fr" : "repeat(4,1fr)",
          }}>
            {ADIMLAR.map(([no, b, m], i) => (
              <Ac key={no} gecikme={i * 60}><Madde no={no} baslik={b} metin={m} /></Ac>
            ))}
          </div></div></section>

      {/* ---------- 6. FARK ---------- */}
      <section style={{ padding: mobil ? "0 0 60px" : "0 0 92px" }}><div style={KAP}><Ac><BolumBas baslik="Diğer ajanslardan farkımız"yan="Altı somut fark. Hepsi sözleşmede yazıyor." /></Ac><div style={{
            display: "grid", gridTemplateColumns: mobil ? "1fr" : "repeat(2,1fr)",
            borderTop: `1px solid ${CIZGI}`,
          }}>
            {FARKLAR.map(([b, m, d], i) => (
              <Ac key={b} gecikme={(i % 2) * 60}><div style={{
                  display: "flex", gap: 16, height: "100%",
                  padding: mobil ? "24px 0 26px" : (i % 2 === 0 ? "26px 36px 28px 0" : "26px 0 28px 36px"),
                  borderBottom: `1px solid ${CIZGI}`,
                  borderLeft: !mobil && i % 2 === 1 ? `1px solid ${CIZGI}` : 0,
                }}><svg width="21" height="21" viewBox="0 0 24 24" fill="none" aria-hidden="true"stroke={ALTIN} strokeWidth="1.4" style={{ flex: "none", marginTop: 2 }}><path d={d} /></svg><div><h3 style={{ fontSize: 18, marginBottom: 6 }}>{b}</h3><p style={{ fontFamily: GOVDE, fontSize: 14.5,
                                color: INK_2, lineHeight: 1.56 }}>{m}</p></div></div></Ac>
            ))}
          </div></div></section>

      {/* ---------- 7. KAPANIŞ ---------- */}
      <section style={{ background: BLOK, color: KAGIT, padding: mobil ? "60px 0" : "92px 0" }}><div style={{
          ...KAP, display: "grid",
          gridTemplateColumns: mobil ? "1fr" : "1.1fr .9fr",
          gap: mobil ? 38 : 56, alignItems: "center",
        }}><Ac><h2 style={{ fontSize: "clamp(32px,4.4vw,54px)", maxWidth: "13ch", color: KAGIT }}>
              Markanız için <span style={{ color: ALTIN_PARLAK }}>doğru adımı</span> atalım.
            </h2><p style={{ fontFamily: GOVDE, marginTop: 20, fontSize: 17,
                        color: "rgba(251,250,246,.65)", maxWidth: "42ch" }}>
              Ücretsiz analiz görüşmesinde markanızı, hedeflerinizi ve büyüme
              fırsatlarınızı birlikte değerlendiriyoruz. Satış konuşması değil,
              tespit toplantısı.
            </p><div style={{ marginTop: 30, display: "flex", gap: 12, flexWrap: "wrap" }}><Dugme tur="altin" href="/iletisim" onClick={git("contact")}>Ücretsiz analiz al</Dugme><Dugme tur="hayalet" href="tel:+908502428674">Bizi arayın</Dugme></div></Ac><Ac gecikme={80}><div style={{
              border: "1px solid rgba(251,250,246,.16)", borderRadius: 14, padding: 28,
            }}><span style={{
                fontFamily: DISPLAY, fontSize: 11.5, fontWeight: 700,
                color: ALTIN_PARLAK, letterSpacing: "0.1em", textTransform: "uppercase",
              }}>Ücretsiz eğitim</span><h3 style={{ fontSize: 23, margin: "11px 0 9px", color: KAGIT }}>
                Reklamı anlamak ister misiniz?
              </h3><p style={{ fontFamily: GOVDE, fontSize: 15,
                          color: "rgba(251,250,246,.6)", marginBottom: 20 }}>
                Kendi reklamını kurmak ya da ajansını daha iyi anlamak isteyenler
                için sıfırdan başlayan bir eğitim. Ücret yok.
              </p><Dugme tur="beyaz" href="/iletisim" onClick={git("contact")}>Eğitime başla</Dugme></div></Ac></div></section></div>
  );
}
